import { GeoJSON } from 'ol/format'
/**
 * @module
 * @api
 */

/**
 * AutoSearch API
 * @constructor
 */
export default function AutoSearch() {
  this.listeners = []
  this.stashedListeners = []
  this.format = new GeoJSON()
}

/**
 * Add event listener
 * @param {string} type event type
 * @param {function} listener callback function
 * @memberof! module:api/AutoSearch#
 * @api
 */
AutoSearch.prototype.on = function(type, callback) {
  this.listeners.push({
    type: type,
    callback: callback
  })
}

/**
 * Remove event listener
 * @param {string} type event type
 * @param {function} listener callback function
 * @memberof! module:api/AutoSearch#
 * @api
 */
AutoSearch.prototype.un = function(type, callback) {
  this.listeners
    .filter(
      listener => listener.type === type && listener.callback === callback
    )
    .forEach(listener => {
      const index = this.listeners.indexOf(listener)
      this.listeners.splice(index, 1)
    })
}

/**
 * Create an event trigger
 * @return {function} trigger function to trigger autosearch events
 */
AutoSearch.prototype.createTrigger = function(type) {
  return feature => {
    let geoJSON
    if (this.listeners.length > 0) {
      if (Array.isArray(feature)) {
        geoJSON = this.format.writeFeaturesObject(feature)
      } else {
        geoJSON = this.format.writeFeatureObject(feature)
      }
    }
    this.listeners
      .filter(listener => listener.type.indexOf(type) > -1)
      .forEach(listener => {
        listener.callback({
          type: type,
          geoJSON: geoJSON
        })
      })
  }
}

AutoSearch.prototype.stashListeners = function() {
  this.stashedListeners = this.listeners
  this.listeners = []
}

AutoSearch.prototype.popListeners = function() {
  this.listeners = this.stashedListeners
  this.stashedListeners = []
}
